import { useEffect, useMemo, useState } from "react";
import { fetchPersonaById } from "../api/perfilesApi";
import { buildPerfilForm } from "../domain/perfilForm";

export function usePerfilLoad({ persona, personaId }) {
    const initial = useMemo(() => buildPerfilForm(persona || {}), [persona]);
    const [form, setForm] = useState(initial);
    const [loadingPersona, setLoadingPersona] = useState(false);

    useEffect(() => {
        setForm(buildPerfilForm(persona || {}));
    }, [persona]);

    useEffect(() => {
        let mounted = true;

        (async () => {
            if (persona || !personaId) return;

            setLoadingPersona(true);
            try {
                const data = await fetchPersonaById(personaId);
                if (!mounted) return;
                setForm(buildPerfilForm(data));
            } catch (e) {
                console.error("Error al cargar persona para edición:", e);
            } finally {
                if (mounted) setLoadingPersona(false);
            }
        })();

        return () => {
            mounted = false;
        };
    }, [persona, personaId]);

    return { form, setForm, loadingPersona };
}
